import { render, staticRenderFns } from "./CoreItemFour.vue?vue&type=template&id=418413f6&scoped=true"
import script from "./CoreItemFour.vue?vue&type=script&lang=js"
export * from "./CoreItemFour.vue?vue&type=script&lang=js"
import style0 from "./CoreItemFour.vue?vue&type=style&index=0&id=418413f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_n4a2vfauuuf6vmcvyn2rbj6bo4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418413f6",
  null
  
)

export default component.exports